import apiClient from "../config/apiClient";


export const fetchClinicalTask = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=patient/admissions/tasks?patient_id=${id}&page=1&limit=12&item_id=&admission_id=&type=`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  